import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import mobiscroll from '@mobiscroll/react'
import '@mobiscroll/react/dist/css/mobiscroll.react.scss'
import './MobiSelectStates.css'
import { reaction, runInAction, toJS } from 'mobx'
import { ReactComponent as DropdownIcon } from '../Assets/dropdown.svg'
import { storeElement } from 'GlobalStores/StoreElement'
import { Stack } from '@mui/material'
import { get, isEmpty, keyBy, lowerCase } from 'lodash'
import { DefaultLabelTypo } from '../InputsStyled'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'

const MobiSelectStates = observer(({ item, label, allItems, forceType }) => {
    const [options, setOptions] = useState([])
    const translate = useTranslate()

    const localObserver = useLocalObservable(() => ({
        listForRender: [],
        value: ''
    }))

    useEffect(() => {
        let data = []
        data = storeCheckout
            .CheckOutInstance()
            .Instance()
            .AddressOptionList(item.key, storeCheckout)
            .map(i => i.value)
        setOptions(data)
    }, [])

    const renderProvinces = async () => {
        try {
            runInAction(() => {
                localObserver.listForRender = []
            })

            let list = []
            list = options.map(province => {
                return {
                    value: province,
                    text: province
                }
            })

            runInAction(() => {
                localObserver.listForRender = list
            })

            setPropValueToState(localObserver.value)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        renderProvinces()
    }, [options])

    const setPropValueToState = propValue => {
        if (propValue) {
            let val = lowerCase(propValue)
            runInAction(() => {
                localObserver.listForRender.map(l => {
                    if (lowerCase(l.text).includes(val)) {
                        localObserver.value = l.value
                    }
                    return l
                })
            })
        }
    }

    useEffect(() => {
        const disposer = reaction(
            () => StoreTranslate.CurrentLanguage(),
            (n, p) => {
                if (n !== p) {
                    renderProvinces()
                }
            }
        )
        return () => {
            disposer()
        }
    }, [])

    useEffect(() => {
        const disposer = reaction(
            () => storeCheckout.CheckOutInstance().Instance().AddressOptionList(item.key, storeCheckout),
            (n, p) => {
                if (n !== p) {
                    let data = []

                    data = storeCheckout
                        .CheckOutInstance()
                        .Instance()
                        .AddressOptionList(item.key, storeCheckout)
                        .map(i => i.value)

                    setOptions(data)
                }
            }
        )
        return () => {
            disposer()
        }
    }, [])

    useEffect(() => {
        const disposer = reaction(
            () => StoreTranslate.CurrentLanguage(),
            (n, p) => {
                if (n !== p) {
                    storeCheckout.SetCheckoutFormValue(item.key, '')
                }
            }
        )
        return () => {
            disposer()
        }
    }, [])

    useEffect(() => {
        if (item.value) {
            if (localObserver.listForRender.length > 0) {
                setPropValueToState(item.value)
            } else if (localObserver.listForRender.length === 0) {
                renderProvinces()
                setPropValueToState(item.value)
            }
        } else {
            if (localObserver.listForRender.length === 0) {
                renderProvinces()
            }
        }
    }, [item.value, localObserver.listForRender.length])

    const onSelected = (event, inst) => {
        storeCheckout.SetCheckoutFormValue(item.key, event.valueText)
    }

    return (
        <Stack>
            <div
                style={{
                    display: 'flex',
                    justifyContent: storeElement.dynamicWidth > 768 && 'space-between',
                    marginBottom: '8px',
                    paddingLeft: '16px'
                }}>
                <label>
                    <DefaultLabelTypo variant="label" style={{ color: 'rgba(21, 56, 98, 0.5)' }}>
                        {label}
                    </DefaultLabelTypo>
                </label>
            </div>

            {/* <label style={{ fontWeight: 400, fontSize: "18px" }}>{props.label}</label> */}
            <Stack className={`mobi-custom-input ${isEmpty(options) ? 'mbsc-disabled-select' : ''}`} sx={{ cursor: 'pointer', '.mbsc-input-wrap input': { cursor: 'pointer' } }}>
                <mobiscroll.Select
                    className={item.key}
                    key={item.key}
                    display="center"
                    touchUi={false}
                    filter={true}
                    height={40}
                    placeholder={translate(item.placeholder)}
                    maxWidth={400}
                    data={localObserver.listForRender}
                    onSet={(e, inst) => onSelected(e, inst)}
                    value={item.value}
                    disabled={isEmpty(options)}
                    filterPlaceholderText=""
                    group={{
                        groupWheel: false,
                        header: false
                    }}
                    filterEmptyText={translate('select_filter_no_result_text')}>
                    <mobiscroll.Input className="disabled" style={{ cursor: 'pointer' }}>
                        <Stack position={'absolute'} right={'15px'} top={'45%'}>
                            <DropdownIcon
                                className={`${isEmpty(options) ? 'dropdown-icon-disabled' : ''}`}
                                style={{ cursor: 'pointer', color: 'rgba(153, 188, 223, 0.25)' }}
                            />
                        </Stack>
                    </mobiscroll.Input>
                </mobiscroll.Select>
            </Stack>
        </Stack>
    )
})

export default MobiSelectStates
